export default __webpack_public_path__ + "static/media/leftarrow.6788c071.svg";